var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          !_vm.initialized
            ? _c("div", { staticClass: "modal-dialog" }, [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c("h5", { staticClass: "modal-title" }, [
                      _vm._v("Delete user"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: { type: "button" },
                        on: { click: _vm.close },
                      },
                      [_vm._v("×")]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary",
                        attrs: { type: "button" },
                        on: { click: _vm.close },
                      },
                      [_vm._v("Cancel")]
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.initialized && _vm.hasDependants
            ? _c(
                "div",
                {
                  staticClass: "modal-dialog modal-lg modal-dialog-scrollable",
                },
                [
                  _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-header" }, [
                      _c("h5", { staticClass: "modal-title" }, [
                        _vm._v("Delete user"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: { type: "button" },
                          on: { click: _vm.close },
                        },
                        [_vm._v("×")]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-body" }, [
                      _c(
                        "div",
                        {
                          staticClass: "alert alert-danger text-dark",
                          attrs: { role: "alert" },
                        },
                        [
                          _c("h5", { staticClass: "alert-heading" }, [
                            _vm._v("Cannot delete this user"),
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("\n                            The user '"),
                            _c("strong", [_vm._v(_vm._s(_vm.projectUserName))]),
                            _vm._v("' is in "),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.dependenciesCount)),
                            ]),
                            _vm._v(
                              " places.\n                            To Delete them & their votes please first remove them from the following Panels.\n                            Alternatively, consider Archiving this user, to keep their previous votes, but stop them being selected for any new panels.\n                        "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _vm.criteriaSurveys.length > 0
                          ? _c("div", { staticClass: "card" }, [
                              _c("div", { staticClass: "card-header" }, [
                                _vm._v(
                                  "\n                                Criteria panels (" +
                                    _vm._s(_vm.criteriaSurveys.length) +
                                    ")\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "list-group list-group-flush" },
                                _vm._l(_vm.criteriaSurveys, function (s) {
                                  return _c(
                                    "li",
                                    {
                                      key: s.Id,
                                      staticClass: "list-group-item",
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          directives: [
                                            {
                                              name: "sanitizedHref",
                                              rawName: "v-sanitizedHref",
                                              value:
                                                _vm.url_CriteriaPanelistsPage(
                                                  s
                                                ),
                                              expression:
                                                "url_CriteriaPanelistsPage(s)",
                                            },
                                          ],
                                          staticClass: "text-primary",
                                          attrs: { target: "_blank" },
                                        },
                                        [_vm._v(_vm._s(s.Name))]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.estimationsSurveys.length > 0
                          ? _c("div", { staticClass: "card mt-2" }, [
                              _c("div", { staticClass: "card-header" }, [
                                _vm._v(
                                  "\n                                Assessments panels (" +
                                    _vm._s(_vm.estimationsSurveys.length) +
                                    ")\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "list-group list-group-flush" },
                                _vm._l(_vm.estimationsSurveys, function (s) {
                                  return _c(
                                    "li",
                                    {
                                      key: s.Id,
                                      staticClass: "list-group-item",
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          directives: [
                                            {
                                              name: "sanitizedHref",
                                              rawName: "v-sanitizedHref",
                                              value:
                                                _vm.url_AssessmentsPanelistsPage(
                                                  s
                                                ),
                                              expression:
                                                "url_AssessmentsPanelistsPage(s)",
                                            },
                                          ],
                                          staticClass: "text-primary",
                                          attrs: { target: "_blank" },
                                        },
                                        [_vm._v(_vm._s(s.Name))]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.scoringSurveys.length > 0
                          ? _c("div", { staticClass: "card mt-2" }, [
                              _c("div", { staticClass: "card-header" }, [
                                _vm._v(
                                  "\n                                Scoring panels (" +
                                    _vm._s(_vm.scoringSurveys.length) +
                                    ")\n                            "
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "list-group list-group-flush" },
                                _vm._l(_vm.scoringSurveys, function (s) {
                                  return _c(
                                    "li",
                                    {
                                      key: s.Id,
                                      staticClass: "list-group-item",
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          directives: [
                                            {
                                              name: "sanitizedHref",
                                              rawName: "v-sanitizedHref",
                                              value:
                                                _vm.url_ScoringPanelistsPage(s),
                                              expression:
                                                "url_ScoringPanelistsPage(s)",
                                            },
                                          ],
                                          staticClass: "text-primary",
                                          attrs: { target: "_blank" },
                                        },
                                        [_vm._v(_vm._s(s.Name))]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              ),
                            ])
                          : _vm._e(),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { type: "button" },
                          on: { click: _vm.archiveProjectUser },
                        },
                        [_vm._v("Archive")]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-secondary",
                          attrs: { type: "button" },
                          on: { click: _vm.close },
                        },
                        [_vm._v("Cancel")]
                      ),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.initialized && !_vm.hasDependants
            ? _c("div", { staticClass: "modal-dialog" }, [
                _c("div", { staticClass: "modal-content" }, [
                  _c(
                    "div",
                    { staticClass: "modal-header bg-danger text-white" },
                    [
                      _c("h5", { staticClass: "modal-title" }, [
                        _vm._v("Delete user"),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close text-white",
                          attrs: { type: "button" },
                          on: { click: _vm.close },
                        },
                        [_vm._v("×")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-body" }, [
                    _c("h4", [
                      _vm._v("Are you sure you want to delete this user?"),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v("You are about to delete '"),
                      _c("strong", [_vm._v(_vm._s(_vm.projectUserName))]),
                      _vm._v("'. This can't be undone."),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-danger",
                        attrs: { type: "button" },
                        on: { click: _vm.deleteProjectUser },
                      },
                      [_vm._v("Delete")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-outline-secondary",
                        attrs: { type: "button" },
                        on: { click: _vm.close },
                      },
                      [_vm._v("Cancel")]
                    ),
                  ]),
                ]),
              ])
            : _vm._e(),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "modal-body" }, [
      _c("h4", [
        _c("i", { staticClass: "fa fa-spinner fa-spin" }),
        _vm._v(" Checking dependencies..."),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }